module.exports = __webpack_public_path__ + "static/media/git--gud-C-yellow.e9dd50e4.svg";